'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandClassNameAndStyle = exports.getGradientClassName = undefined;
exports.buildColorRecord = buildColorRecord;
exports.hexToRgba = hexToRgba;

var _textColorUtils = require('ui-addon-conversations/utils/textColorUtils');

var _BaseBrandColors = require('conversations-schema/constants/BaseBrandColors');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGradientClassName = exports.getGradientClassName = function getGradientClassName(color) {
  switch (color) {
    case _BaseBrandColors.FIRST_COLOR:
      return 'brand-color-element first';
    case _BaseBrandColors.SECOND_COLOR:
      return 'brand-color-element second';
    case _BaseBrandColors.THIRD_COLOR:
      return 'brand-color-element third';
    case _BaseBrandColors.FOURTH_COLOR:
      return 'brand-color-element fourth';
    case _BaseBrandColors.FIFTH_COLOR:
      return 'brand-color-element fifth';
    default:
      return '';
  }
};

var getBrandClassNameAndStyle = exports.getBrandClassNameAndStyle = function getBrandClassNameAndStyle(accentColor, elementClassName) {
  var gradientClassName = getGradientClassName(accentColor);
  var className = elementClassName + ' ' + gradientClassName;
  var style = gradientClassName ? null : { backgroundColor: accentColor };

  return {
    className: className,
    style: style
  };
};

function buildColorRecord(accentColor) {
  if (accentColor == null) {
    return new _ColoringRecord2.default();
  }

  return new _ColoringRecord2.default({
    accentColor: accentColor,
    textColor: (0, _textColorUtils.getTextColor)(accentColor),
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDefaultColor: (0, _textColorUtils.useDefaultElementColor)(accentColor)
  });
}

function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    var red = parseInt(result[1], 16);
    var green = parseInt(result[2], 16);
    var blue = parseInt(result[3], 16);
    return red + ', ' + green + ', ' + blue + ', ' + alpha;
  }
  return null;
}